<template>
    <div
        class="c-moreFilters row flex-nowrap full-width js-more-filters-nav"
        :class="{'is-active': showPanel==true}"
        :data-component-name="$options.name"
    >
        <div class="col -group" v-if="currentRoute=='staffs' && showPanel">
            <div class="row">
                <h3 class="full-width"></h3>
                <div class="col -filter">
                    <UserProfileInput
                        popup-content-class="red"
                        label="Utilisateurs"
                        multiple
                        v-model="userProfiles"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <TagInput
                        label="Professions"
                        multiple
                        v-model="professions"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="PROFESSION"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <TagInput
                        label="Formations"
                        multiple
                        v-model="courses"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="COURSE"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <CompaniesInput
                        label="Compagnies"
                        multiple
                        v-model="companies"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="PROFESSION"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                <!-- {{ projects }} -->
                    <ProjectInput
                        label="Projets"
                        multiple
                        v-model="projects"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                        @set-assignments-tyoe="assignmentsType = $event"
                    />
                </div>
            </div>
        </div>
        <div class="col -group" v-if="currentRoute=='projects' && showPanel">
            <div class="row">
                <h3 class="full-width">Affectations</h3>
                <div class="col -filter">
                    <UserProfileInput
                        label="Utilisateurs affectés"
                        multiple
                        v-model="userProfiles"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        :dense="true"
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <TagInput
                        label="Professions"
                        multiple
                        v-model="professions"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="PROFESSION"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <CompaniesInput
                        label="Compagnies"
                        multiple
                        v-model="companies"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="PROFESSION"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
            </div>
        </div>
        <div class="col -group" v-if="currentRoute=='projects' && showPanel">
            <div class="row">
                <h3 class="full-width">Projets</h3>
                <div class="col -filter">
                    <UserProfileInput
                        label="Chargés de projet"
                        multiple
                        v-model="projectManagers"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <CustomerInput
                        label="Clients"
                        multiple
                        v-model="customers"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <UserProfileInput
                        label="Superviseurs des travaux"
                        multiple
                        v-model="supervisors"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />
                </div>
                <div class="col -filter">
                    <ProjectCategoryInput
                        label="Catégories de projet"
                        multiple
                        v-model="projectCategories"
                        class="c-moreFilters-select --project-categories"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        :filled="false"
                        dense
                        :outlined="true"
                        dark
                    />

                    <!-- <TagInput
                        label="Formations"
                        :filled="false"
                        borderless
                        multiple
                        v-model="courses"
                        class="c-moreFilters-select"
                        :popupContentClass="'c-moreFilters-popup'"
                        :showMax="2"
                        tagType="COURSE"
                    /> -->
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    
export default {
    name: 'MoreFilters',
    //components: { Component1, Component2 },
    props: {
        currentView:{
            type: String,
            default: 'projects',
        },
    },
    data(){
        return {
            showPanel: false,
            projects: null,
            assignmentsType: 'assignments',
            courses: null,
            projectCategories: null,
            professions: null,
            companies: null,
            projectManagers: null,
            customers: null,
            supervisors: null,
            userProfiles: null,
            // savedFilters: {
            //     projects: null,
            //     staffs: null,
            // },
            // moreFilters: null
        }
    },
    mounted() {
        // console.log('MoreFilters mounted')

        let savedFilters = this.$q.localStorage.getItem('savedFilters')
        if (savedFilters) savedFilters = JSON.parse(savedFilters)
        if ( savedFilters && savedFilters[this.currentRoute] ) {
            Object.keys(savedFilters[this.currentRoute]).forEach((key)=>{
                this[key] = savedFilters[this.currentRoute][key]
            })
        }

        let filtersVisible = this.$q.localStorage.getItem('filtersVisible'+this.currentRoute);
        if (filtersVisible && this.moreFilters) {
            this.$nextTick(()=>{
                this.showPanel = filtersVisible
                // console.log(this.moreFilters)
            })
        }


        this.$eventBus.$on('toggle-more-filters', function () {
            this.showPanel=!this.showPanel
        }.bind(this))
    },
    computed: {
        currentRoute: function(){
            // return this.$route.path.split('/')[1];
            return this.$route.name;
        },
        moreFilters(){
            let moreFilters=null

            if (this.professions) {
                if(!moreFilters) moreFilters={};
                if( !moreFilters.professions ) moreFilters.professions=[];
                this.professions.forEach(function(item){
                    moreFilters.professions.push(item.id)
                })
            }
            if(this.companies){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.companies ) moreFilters.companies=[];
                this.companies.forEach(function(item){
                    moreFilters.companies.push(item.id)
                })
            }
            if(this.projects){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.projects ) moreFilters.projects=[];
                this.projects.forEach(function(item){
                    moreFilters.projects.push(item.id)
                })
            }
            if(this.assignmentsType){
                if(!moreFilters) moreFilters={};
                moreFilters.assignmentsType = this.assignmentsType;
            }
            if(this.courses){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.courses ) moreFilters.courses=[];
                this.courses.forEach(function(item){
                    moreFilters.courses.push(item.id)
                })
            }
            if(this.projectCategories){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.projectCategories ) moreFilters.projectCategories=[];
                this.projectCategories.forEach(function(item){
                    moreFilters.projectCategories.push(item.id)
                })
            }
            if(this.projectManagers){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.projectManagers ) moreFilters.projectManagers=[];
                this.projectManagers.forEach(function(item){
                    moreFilters.projectManagers.push(item.id)
                })
            }
            if(this.customers){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.customers ) moreFilters.customers=[];
                this.customers.forEach(function(item){
                    moreFilters.customers.push(item.id)
                })
            }
            if(this.supervisors){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.supervisors ) moreFilters.supervisors=[];
                this.supervisors.forEach(function(item){
                    moreFilters.supervisors.push(item.id)
                })
            }
            if(this.userProfiles){
                if(!moreFilters) moreFilters={};
                if( !moreFilters.userProfiles ) moreFilters.userProfiles=[];
                this.userProfiles.forEach(function(item){
                    moreFilters.userProfiles.push(item.id)
                })
            }

            return moreFilters
        }
    },
    watch: {
        showPanel() {
            
            if(this.showPanel==false) {
                this.$emit('set-more-filters', null)
            }else{
                this.$emit('set-more-filters', this.moreFilters)
            }

            this.$q.localStorage.set('filtersVisible' + this.currentRoute, this.showPanel);

            if (this.showPanel) document.querySelector('.js-filters-toggle').classList.add('is-active')
            if (!this.showPanel) document.querySelector('.js-filters-toggle').classList.remove('is-active')
        },
        moreFilters() {

            if (!this.showPanel) {
                this.$emit('set-more-filters', null)
                return
            }
            // console.log('morefilters')
            // let savedFilters = {}
            let savedFilters = this.$q.localStorage.getItem('savedFilters')
            if (savedFilters) savedFilters = JSON.parse(savedFilters)
            if (!savedFilters) savedFilters = {}

            savedFilters[this.currentRoute] = {
                courses: this.courses,
                projectCategories: this.projectCategories,
                professions: this.professions,
                companies: this.companies,
                projectManagers: this.projectManagers,
                customers: this.customers,
                supervisors: this.supervisors,
                userProfiles: this.userProfiles,
                projects: this.projects,
            }

            this.$q.localStorage.set('savedFilters', JSON.stringify(savedFilters))

            this.$emit('set-more-filters', this.moreFilters)
        }
    },
    methods: {
        setMoreFilters(){
            // this.$emit('set-more-filters', this.moreFilters)
        }
    },
}
</script>

<style lang="scss">
    @import '@/scss/settings/_fonts.scss';

    // .c-moreFilters-popup {
    //     font-size: 10px;
    //     font-weight: 800;
    //     border-radius: none !important;
    //     .c-select-filter-input {
    //         background-color: $color-0-light;
    //         color: $color-1-mid;
    //         font-size: 9px;
    //         font-weight: 400;
    //         padding: 0;
    //         line-height: 12px;
            
    //         & .q-field__control {
    //             height: unset;
    //         }

    //         & input.q-field__native {
    //             padding: 9px;
    //             line-height: 9px;
    //         }
    //     }
    // }

    .c-moreFilters {
        & .c-moreFilters-select {
            & .q-field__native {
                font-size: 11px !important;

                &>span {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    font-family: $font-ellipsis;
                }
            }
            & .q-field--float .q-field__label {
                // transform: translateY(-14px);
            }
            & .q-field__label {
                color: $color-0-dark;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-family: $font-ellipsis; 
                // font-size: 9px !important;
                // top: 16px;
           }

           & .q-field__marginal {
                // font-size: 12px;
                max-height: 38px;
                // align-items: flex-end;
                // padding-bottom: 7px;

                & .q-icon.q-field__focusable-action {
                    color: $color-4;
                }
           }
        }

        .--project-categories {
           & .q-field__native.row.items-center{
                flex-wrap: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                &>span {
                    flex-shrink: 0;
                }
            }

        }

    }
</style>
<style lang="scss" scoped>
    .c-moreFilters {
        height: 0px;
        transition: height $speed $easing;
        background-color: $color-1-darker;
        // background-color: $white;
        overflow: hidden;
        color: $color-1-dark;

        &.is-active {
            max-height: 86px;
            height: 86px;
            transition: height $speed $easing;

            .c-staffs-vue & {
                max-height: 68px;
                height: 68px;
            }
        }
        & h3 {
            width: 100%;
            padding: 10px 0 6px;
            color: $color-0-dark;
        }

        & .col.-group {
            border-right: 1px solid $color-1;
            border-bottom: 1px solid $color-1;
            padding: 0 30px;
            &>.row {
                // align-items: center;
            }
        }

        & .col.-filter {
            max-width: 360px;
            padding: 0px 20px 0 0;

            &:last-child {
                padding-right: 0;
            }
        }

        & .col-close {
            flex-grow: 0;
            // width: 20px;
            // min-width: 20px;
            padding: 0 4px;
            color: $color-0-mid;
            border-right: 1px solid $color-0-mid;

            display: flex;
            align-items: center;
        }

        & .c-moreFilters-select {
            // border-bottom: 1px solid $color-0-light;
            max-height: 38px;
            // & .q-field__native {
                

            //     &>span {
            //         white-space: nowrap;
            //         overflow: hidden;
            //         text-overflow: ellipsis;
            //     }
            // }
        }

    }
</style>